import React, { useState } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { SearchNormalIcon } from 'icons';
import { useRouter } from 'next/navigation';
import { useTranslations } from 'next-intl';

import { useAppSelector } from 'store';

import { globalConst } from 'modules/global';

const SearchInput = () => {
  const t = useTranslations()
  const router = useRouter();
  const [tempValue, setTempValue] = useState<string>('');
  const isRouteLoading = useAppSelector(({ routeLoading }) => routeLoading.isRouteLoading);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTempValue(e.target.value);
  };

  const handleSearch = () => {
    const trimmedValue = tempValue.trim();

    if (trimmedValue) {
      router.push(`${globalConst.pageNames.COURSES_FILTER}?search=${encodeURIComponent(trimmedValue)}`);
    }
  };

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <div className="relative mt-3">
      <input
        type="text"
        value={tempValue}
        onChange={onChange}
        disabled={isRouteLoading}
        onKeyDown={onKeyDown}
        placeholder={`${t('turli_kurslarni_qidirish')}...`}
        className="block w-80 rounded-full bg-white py-1.5 pl-3 pr-10 text-sm leading-5 placeholder-gray-500 focus:border-green-500 focus:placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-green-500 disabled:cursor-not-allowed disabled:opacity-50"
      />

      <div
        className="absolute inset-y-0 right-0 flex cursor-pointer items-center rounded-full pr-3 !text-green-500"
        onClick={handleSearch}
      >
        {isRouteLoading ? <LoadingOutlined spin className="text-lg" /> : <SearchNormalIcon />}
      </div>
    </div>
  );
};

export default SearchInput;
